import React from 'react';

import { ReactComponent as DropdownArrow } from '../../../assets/icons/device-management/right-arrow.svg';
import { MultiLevelMenuDropdownProperties } from '../../../interface/shared-component.interface';

interface RecursiveDropdownProperties {
  items: MultiLevelMenuDropdownProperties[];
  onSelectToggle: (id: string, isElementSelection: boolean) => void;
  level: number;
}

/**
 * Recursive element mapping function
 * @param properties
 * @returns
 */
function RecursiveDropdown(properties: RecursiveDropdownProperties) {
  const { items, onSelectToggle, level } = properties;

  return (
    <ul className="multi-level-dropdown-menu-wrap">
      {items.map((item) => (
        <li
          key={item.id}
          className={`each-main-menu-wrap ${level === 0 && item.isSelected && 'each-main-menu-active-wrap'}`}>
          <div
            role="presentation"
            onClick={() => onSelectToggle(item.id, !item.hasSubMenu)}
            className={`menu-container ${level === 0 && item.isSelected && 'active-first-menu'} ${level !== 0 && item.isSelected && 'active-menu'}`}
            style={{ '--level': level } as React.CSSProperties}>
            <div className="menu">
              <span style={{ opacity: item.hasSubMenu ? '1' : '0' }}>
                <DropdownArrow />
              </span>
              <p>{item.label}</p>
            </div>
          </div>

          {item.hasSubMenu && item.isSelected && item?.subMenu && item.subMenu?.length > 0 && (
            <RecursiveDropdown
              items={item.subMenu}
              onSelectToggle={onSelectToggle}
              level={level + 1} // Increment level on recursion
            />
          )}
        </li>
      ))}
    </ul>
  );
}

export default RecursiveDropdown;
